import AuthFieldErrorMessage from '@/components/Auth/AuthFieldErrorMessage'
import CodeEntryField from '@/components/UI/CodeEntryField/CodeEntryField'
import { logger } from '@/features/auth/logger'
import { useAppDispatch } from '@/hooks/redux'
import { useScreenOrientation, useScreenSize } from '@/hooks/screen'
import { fetchAuthDeviceToken, fetchAuthProfiles } from '@/redux/reducers/auth'
import { isThunkRejectValue } from '@/redux/utils'
import { getAuthDeviceErrorTranslation } from '@/utils/auth/translation'
import { router } from 'expo-router'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const codeLength = 6

const AuthDeviceCodeField: FC = () => {
    const screenSize = useScreenSize()
    const screenOrientation = useScreenOrientation()

    const dispatch = useAppDispatch()

    const [errorMessage, setErrorMessage] = useState<string>()

    const { t } = useTranslation()

    const handleSubmitEditing = async (code: string) => {
        if (code.length < codeLength) return

        try {
            await dispatch(fetchAuthDeviceToken(code)).unwrap()
            await dispatch(fetchAuthProfiles()).unwrap()
        } catch (e) {
            let errorMessage: string

            if (isThunkRejectValue(e)) {
                errorMessage = t(getAuthDeviceErrorTranslation(e))
            } else {
                logger.errorOnly(e)

                errorMessage = t('unexpectedError')
            }

            return setErrorMessage(errorMessage)
        }

        router.replace('/auth/profiles')
    }

    const marginTop = screenSize === 'small' && screenOrientation === 'landscape' ? 8 : 32

    return (
        <View style={[styles.container, { marginTop }]}>
            <CodeEntryField length={codeLength} onSubmitEditing={handleSubmitEditing} />
            {errorMessage && <AuthFieldErrorMessage>{errorMessage}</AuthFieldErrorMessage>}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 16,
    },
})

export default AuthDeviceCodeField
